module.exports = __webpack_public_path__ + "static/media/border-outer.cd3b7ab0.svg";